import type { ITransaction } from '@recargas-dominicanas/core/types';
import { expired, formatCurrency, formatVigency } from '@recargas-dominicanas/core/utils';
import { DetailModal } from '../detail-modal/detail-modal.component';
import { DetailModalItem } from '../detail-modal-item/detail-modal-item.component';

import { 
  ModalContent,
  OutlineButton, 
  ModalOptions
} from '@recargas-dominicanas/core/components';

interface Props {
  open: boolean;
  title: string;
  transaction: ITransaction;
  overlayEnterAnimation?: boolean;
  onPrint?: () => void;
  onCancel?: () => void;
  onClose: () => void;
}

export function InsuranceModal(props: Props) {

  const {
    open,
    title,
    transaction,
    overlayEnterAnimation,
    onPrint,
    onCancel,
    onClose
  } = props;

  return (
    <DetailModal
      open={open} 
      title={title}
      overlayEnterAnimation={overlayEnterAnimation}
      onClose={onClose}>
      <ModalContent>
        <DetailModalItem title='Compañía' text={transaction.product.name}/>
        <DetailModalItem title='Vehiculo' text={transaction.insurance!.vehicleName}/>
        <DetailModalItem title='Chasis' text={transaction.insurance!.chassis}/>
        <DetailModalItem title='Poliza' text={transaction.insurance!.policy}/>
        <DetailModalItem title='Vigencia' text={formatVigency(transaction.insurance!.vigency)}/>
        <DetailModalItem title='Precio' color='green' text={formatCurrency(transaction.amount)}/>
        <DetailModalItem title='Beneficio' color='green' text={formatCurrency(transaction.profit)}/>
        <DetailModalItem title='Referencia' text={transaction.insurance!.id}/>
        {transaction.cancelled &&
          <DetailModalItem title='Estado' text='Cancelado'/>
        }
      </ModalContent>
      <ModalOptions>
        {onPrint &&
          <OutlineButton 
            icon='receipt' 
            text='Imprimir' 
            onClick={onPrint}/>
        }
        {transaction && onCancel && !transaction.cancelled && !expired(transaction) &&
          <OutlineButton 
            icon='cancel' 
            text='Cancelar'
            onClick={onCancel}/>
        }
      </ModalOptions>
    </DetailModal>
  );
}
